import React from 'react';
import { ShieldCheck } from 'lucide-react';

export function VerifiedBadge({ className = '' }) {
  return (
    <span
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-md bg-green-500/10 border border-green-500/20 text-green-400 text-xs font-medium ${className}`}
      data-testid="verified-badge"
      title="Identity Verified via KYC"
    >
      <ShieldCheck className="w-3 h-3" />
      Verified
    </span>
  );
}
